import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledTag = styled.span<{ isDarkMode: boolean; isSelected?: boolean }>`
  padding: 0.7rem 1.2rem;
  border-radius: ${({ theme }) => theme.radius.huge};
  background-color: ${({ theme, isDarkMode, isSelected }) => {
    if (isDarkMode) return 'rgba(45, 61, 95, 1)';
    if (isSelected) return theme.colors.secondary.main;
    return theme.colors.grey[200];
  }};
  cursor: pointer;
`;

export const StyledDismissButton = styled.button`
  margin-left: 0.4rem;
`;

export const StyledTagIcon = styled(FontAwesomeIcon)`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.grey[200]};
`;

export const StyledOSIcon = styled(FontAwesomeIcon)<{ isDarkMode: boolean; isSelected?: boolean }>`
  font-size: 1.2rem;
  margin-right: 0.4rem;
  color: ${({ theme, isDarkMode, isSelected }) => {
    if (isDarkMode) return theme.colors.grey[100];
    if (isSelected) return theme.colors.grey[500];
    return theme.colors.grey[900];
  }};
`;

export const StyledTagText = styled.span<{ isDarkMode: boolean; isSelected?: boolean }>`
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ theme, isDarkMode, isSelected }) => {
    if (isDarkMode) return theme.colors.grey[200];
    if (isSelected) return theme.colors.grey[100];
    return theme.colors.secondary.dark;
  }};
`;
